import React from "react";
import Chart from "react-apexcharts";

// Types
import { NonAxisChartProps } from "@/@types/ui/Charts";

export const PieChart = (props: NonAxisChartProps) => {
  const { data, options } = props;

  const colors = [
    "#FF0000",
    "#008000",
    "#0000FF",
    "#FFA500",
    "#FFC0CB",
    "#3CB371",
    "#800080",
    "#008080",
    "#FF4500",
    "#6A5ACD",
    "#32CD32",
    "#FF69B4",
    "#8A2BE2",
    "#FF8C00",
  ];

  return (
    <Chart
      series={data.series}
      options={{ colors, ...options, labels: data.labels }}
      type="pie"
      height="300px"
    />
  );
};
